import invariant from 'invariant';

interface GetFounditProductsProps {
    founditUrl: string;
    type: 'page' | 'product';
    apiKey: string;
    pageUrl: string;
}

function filterUnwantedParams({ name, value }: { name: string; value: string }) {
    if (!name.includes('facet')) {
        return false;
    }
    const excludedFacetIds: Array<string> = [];
    for (const id of excludedFacetIds) {
        if (name === 'facet' && value.includes(id)) return false;
    }

    return true;
}

export default function getFounditByPage({ founditUrl = 'http://rtapi.foundit.com', type, apiKey, pageUrl }: GetFounditProductsProps) {
    invariant(type, 'type is a required param of getFounditByPage()');
    invariant(apiKey, 'apiKey is a required param of getFounditByPage()');
    invariant(pageUrl, 'pageUrl is a required param of getFounditByPage()');

    const originalUrl = new URL(pageUrl);
    const filteredSearchParams = new URLSearchParams();

    for (const pair of Array.from(originalUrl.searchParams.entries())) {
        filterUnwantedParams({ name: pair[0], value: pair[1] }) && filteredSearchParams.append(pair[0], pair[1]);
    }
    const paramsToAppend = filteredSearchParams.toString().length ? '?' + filteredSearchParams.toString() : '';
    const filteredUrl = originalUrl.origin + originalUrl.pathname + paramsToAppend;

    // the endpoint will only work with double decoding.
    let encodedPageUrl = encodeURIComponent(filteredUrl);
    encodedPageUrl = encodeURIComponent(encodedPageUrl);

    // triple encode as the pageUrl get decoded once when http is redirected to https
    if (founditUrl.indexOf('http:') > -1) encodedPageUrl = encodeURIComponent(encodedPageUrl);

    const url = `${founditUrl}/${type}/${apiKey}/${encodedPageUrl}`;
    return new Request(url);
}
